module.exports = __webpack_public_path__ + "img/location.047a4c01.svg";